export const plans = {
  title: "Choose your plan",
  subtitle: "Price per unit per month, with volume discounts. You can combine several property types in one order.",
  typeLabel: "Property type",
  types: {
    apartamento: "Apartments",
    hotel: "Hotel",
    camping: "Campsite",
    villa: "Villas",
  },
  units: {
    apartamento: "apartment | apartments",
    hotel: "room | rooms",
    camping: "unit | units",
    villa: "villa | villas",
  },
  decrease: "Remove one unit",
  increase: "Add one unit",
  billing: {
    label: "Billing",
    monthly: "Monthly",
    annual: "Annual",
    annualSave: "−20%",
  },
  perUnit: "/mo per unit",
  totalLine: "{qty} {units} · {total}/mo in total",
  billedAnnually: "billed annually",
  add: "Add to order",
  isNew: "New",
  pro: {
    badge: "Most popular",
    tagline: "The whole platform: AI, channels, payments and revenue.",
    f1: "Online check-in and automatic guest reports to the authorities",
    f2: "24/7 AI front desk on WhatsApp: answers, resolves questions and automates",
    f3: "Unified inbox (WhatsApp + Booking, Airbnb and Expedia), translation and handoff to a human",
    f4: "VeriFactu electronic invoicing",
    f5: "Channel Manager with 100+ OTAs, unified calendar and rate management (zero overbooking)",
    f6: "Direct bookings with your own website, commission-free",
    f7: "Smart locks with automatic access codes",
    f8: "Add-ons and upselling, stay extensions and promotions",
    f9: "Payments and charges with deposits",
    f10: "Cleaning and team, with roles and permissions",
    f11: "Multi-property, analytics and per-owner reports",
  },
  suite: {
    badge: "All included",
    tagline: "The most complete plan: AI phone reception, your own website and dynamic pricing.",
    lead: "Everything in Pro, plus:",
    s1: "Your own number for WhatsApp and calls",
    s2: "AI phone reception: answers the phone 24/7 in the guest's language",
    s3: "Inbound calls: 40 min/mo included",
    s4: "WebBuilder: your complete website",
    s5: "Dynamic pricing: automatic rate adjustment",
    s6: "Multiple billing entities to assign to each property",
  },
  cart: {
    title: "Your order",
    empty: "Choose the property type and units, then add a plan.",
    plan: "{plan} plan",
    remove: "Remove",
    monthlyTotal: "Total per month",
    annualTotal: "Billed annually: {total}",
    planSwitched: "An order has a single plan: everything is now {plan}.",
    welcomeTitle: "Invitation discount applied",
    welcomeMonthly: "{percent}% off your first {months} months: {total}/mo",
    welcomeAnnual: "You save {amount} on your first annual invoice",
    pay: "Continue to payment",
    paying: "Opening payment…",
    taxes: "Taxes not included. Stripe will ask for your billing details.",
    error: "We couldn't open the payment. Please try again.",
  },
  payment: {
    success: "Payment received. Your plan will be active in a few seconds.",
    failed: "The payment wasn't completed. You can try again whenever you want.",
    active: "All set! Your plan is active.",
  },
  active: {
    includes: "What your plan includes",
    discount: "Invitation discount: {percent}% until {date}",
    discountAnnual: "Invitation discount applied to your first invoice",
    referralCredit: "You have {amount} in credit for inviting other hosts: it will be deducted from your next invoice.",
  },
};
